import React from "react";
import { useTranslation } from "react-i18next";
import './SkipNow.css';

const EasyPayPlanSkipNow = (props) => {
     const { t } = useTranslation(["translation"]);
    const { handleSkipNow } = props;
    return (
        <div className="brother-plus-banner skip-for-now-container align-to-center">
            <p onClick={handleSkipNow}>{t('BROTHER_PLUS.EASY_PAY_BANNER.SKIP_FOR_NOW')}</p>
        </div>
    );
};

export default EasyPayPlanSkipNow;